module.exports = __webpack_public_path__ + "static/media/slider_2.1355db5e.jpg";